import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { DashboardListPage } from './pages/DashboardListPage';
import { DashboardViewPage } from './pages/DashboardViewPage';
import { DashboardBuilderPage } from './pages/DashboardBuilderPage';

/**
 * Wallboard Routes
 * 
 * Provides routing for the dashboard/wallboard feature.
 * All routes are nested under /wallboard/*
 */
export const WallboardRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Dashboard List */}
      <Route index element={<DashboardListPage />} />
      
      {/* Create New Dashboard */}
      <Route path="new" element={<DashboardBuilderPage />} />
      
      {/* View Dashboard */}
      <Route path="view/:id" element={<DashboardViewPage />} />
      
      {/* Edit Dashboard */}
      <Route path="edit/:id" element={<DashboardBuilderPage />} />
      
      {/* Redirect unknown paths to list */}
      <Route path="*" element={<Navigate to="/wallboard" replace />} />
    </Routes>
  );
};

export default WallboardRoutes;
